import React, { FunctionComponent } from 'react'
import { cn } from 'ethcss'
import { ITabProps } from './Tab-types'
import { tabStyles } from './Tab-styles'

export const Tab: FunctionComponent<ITabProps> = ({
    id,
    label,
    selected,
    disabled = false,
    controls,
    className,
    onSelect,
    onKeyDown,
}) => (
    <button
        id={`tab-${id}`}
        type="button"
        role="tab"
        aria-selected={selected}
        aria-controls={controls}
        tabIndex={selected ? 0 : -1}
        disabled={disabled}
        className={cn(tabStyles.tab, className, {
            [tabStyles.selected]: selected,
            [tabStyles.disabled]: disabled,
        })}
        onClick={() => onSelect(id)}
        onKeyDown={(event) => onKeyDown && onKeyDown(event, id)}
    >
        {label}
    </button>
)
